import pg from '../assets/projects/pg.png';
import messapp from '../assets/projects/messapp.png';
import chatapp from '../assets/projects/chatapp.png';
import gpt4 from '../assets/projects/sum.png';
const projectInfo = [
  {
    id: 1,
    title: 'AmazeKart E-Com',
    description:
      'This ecommerce website allows for easy CRUD operations on user profiles, products and admin panel. The user interface is designed for efficient product management and includes a complete purchase process. The admin panel, accessible for CRUD on users and products, includes a chart for statistics display. The website uses MongoDB as the database.',
    imgPath: pg,
    isBlog: false,
    ghLink: 'https://github.com/harsh774/next-tailwind-amazkart',
  },
  {
    id: 2,
    title: 'React Chat-Application',
    description:
      'This Chat-App is a real time chat portal, in this users can chat, share emojis and files in their conversation. It is completely authenticated website, authentication is done by using firebase. This react website also uses firebase as a database where usersChat, usersDetails are stored. An user can find another user(if exists) also in this project.',
    imgPath: chatapp,
    isBlog: false,
    ghLink: 'https://github.com/harsh774/ChatApp',
    demoLink: 'https://chat-app-by-harsh.web.app/',
  },
  {
    id: 3,
    title: 'Open-AI GPT-4 Articles and Blog Summarizer',
    description:
      "This project is a web application that utilizes OpenAI's ChatGPT-4 language model to summarize articles and blog posts. It provides a user-friendly interface where users can input a URL or directly enter text, and the application will generate a concise summary of the content.",
    imgPath: gpt4,
    isBlog: false,
    ghLink: 'https://github.com/harsh774/chatgpt/tree/master',
    demoLink:
      'https://64bf80c6dc59c638f3fa6087--gentle-donut-6e0556.netlify.app/',
  },
  {
    id: 4,
    title: 'Node.JS User Management System',
    description:
      'Developed a user management system using MERN stack. The system allows admins to provision new users, update user details, remove users, and read the list of users.',
    imgPath: pg,
    isBlog: false,
    ghLink: 'https://github.com/harsh774/User_Management_MERN',
  },
  {
    id: 5,
    title: 'My Mess Scheduler',
    description:
      "This platform features a responsive interface built with Reactjs and CSS, allowing users to easily manage their mess schedule and to get updates about particular day food options, avilability, and other relevant details. The option to add more item and filtering according to their choice(eg. Veg or Non-Veg) is also available. This is complete front-end project which uses some manauly created API's call to function itself.",
    imgPath: messapp,
    isBlog: false,
    ghLink: 'https://github.com/harsh774/my_mess_schedule',
    demoLink: 'https://beautiful-vacherin-2e3319.netlify.app/',
  },
  {
    id: 6,
    title: 'PetroFuel (Mobile Application)',
    description:
      'PetroFuel is made with one sole purpose of calculating the amount of fuel required by the user to cover a particular distance on basis of the average, mileage of the vehicle of the user. This is an android app where other features like real time petrol price across the Indian states. Also the user can find mileage of his/her vehicle.',
    imgPath: pg,
    isBlog: false,
    ghLink: 'https://github.com/harsh774/PetroFuel-1',
  },
];

export default projectInfo;
